<ion-icon name="help-circle" class="open" (click)="showHelp = true"></ion-icon>

<ion-modal class="help-modal" [isOpen]="showHelp" (didDismiss)="showHelp = false">
  <ng-template>
    <div class="wrapper">
      <ion-icon class="close" name="close" (click)="showHelp = false"></ion-icon>
      <app-site-content [key]="key"></app-site-content>
    </div>
  </ng-template>
</ion-modal>
